import {Component, Prop, Vue, Watch} from '@/node_modules/nuxt-property-decorator';
import RoutingUtil from "@/classes/view/routing-util";
import APage from '@/classes/page/a-page';
import {appModule} from '@/store/app';

@Component({
	layout: 'teaser'
})
export default class Index extends APage {

	public title: string;

    ///////// 全ページ共通 ////////////////////////////////////////////
    public mypagetype: string = 'official-concept';
	public mydivider: string = 'full';


    ///////// このページ ////////////////////////////////////////////


    // ヘッダタグの構成要素
    public head() {
        return {
            title: 'コンセプト｜THOUGHT ブランディングツール'
        }
    }

    ///////// 全ページ共通 ////////////////////////////////////////////
    public transition(to: any, from: any) {
		return RoutingUtil.transition(to, from);
	}

    public created(){

		///////// 全ページ共通 ////////////////////////////////////////////
		this.setPagetype( appModule, this.mypagetype, this.mydivider );


        ///////// このページ ////////////////////////////////////////////
    }

    ///////// Computed ////////////////////////////////////////////


	public get deviceSize(): any {
    	return appModule.deviceSize;
	}
}




